import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const InputMeta: ComponentMeta = {
  componentName: "Input",
  package: "@mijadesign/web",
  title: "输入框",
  description: "通过鼠标或键盘输入内容",
  category: ComponentCategory.FORM,
  icon: "EditOutlined",
  canHaveChildren: false,
  designToken: {
    fields: [
      { name: "colorBorder", label: "边框颜色", type: "color" },
      { name: "hoverBorderColor", label: "悬浮边框", type: "color" },
      { name: "activeBorderColor", label: "激活边框", type: "color" },
      { name: "borderRadius", label: "圆角", type: "number", min: 0, max: 48 },
    ],
  },
  props: [
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "请输入",
      group: "基础",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "maxLength",
      label: "最大长度",
      type: PropType.NUMBER,
      group: "验证",
    },
    {
      name: "showCount",
      label: "显示计数",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "addonBefore",
      label: "前置标签",
      type: PropType.STRING,
      group: "装饰",
    },
    {
      name: "addonAfter",
      label: "后置标签",
      type: PropType.STRING,
      group: "装饰",
    },
    {
      name: "prefix",
      label: "前缀",
      type: PropType.STRING,
      group: "装饰",
    },
    {
      name: "suffix",
      label: "后缀",
      type: PropType.STRING,
      group: "装饰",
    },
  ],
  defaultProps: {
    placeholder: "请输入",
  },
  defaultStyle: {
    width: 200,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Input",
  },
  snippet: {
    componentName: "Input",
    package: "@mijadesign/web",
    props: { placeholder: "请输入" },
  },
};

export const InputTextAreaMeta: ComponentMeta = {
  componentName: "Input.TextArea",
  package: "@mijadesign/web",
  title: "文本域",
  description: "用于多行输入",
  category: ComponentCategory.FORM,
  icon: "FileTextOutlined",
  canHaveChildren: false,
  designToken: {
    themeComponentName: "Input",
    fields: [
      { name: "colorBorder", label: "边框颜色", type: "color" },
      { name: "hoverBorderColor", label: "悬浮边框", type: "color" },
      { name: "activeBorderColor", label: "激活边框", type: "color" },
      { name: "borderRadius", label: "圆角", type: "number", min: 0, max: 48 },
    ],
  },
  props: [
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "请输入",
      group: "基础",
    },
    {
      name: "rows",
      label: "行数",
      type: PropType.NUMBER,
      defaultValue: 4,
      group: "基础",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "maxLength",
      label: "最大长度",
      type: PropType.NUMBER,
      group: "验证",
    },
    {
      name: "showCount",
      label: "显示计数",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "autoSize",
      label: "自适应高度",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "布局",
    },
  ],
  defaultProps: {
    placeholder: "请输入",
    rows: 4,
  },
  defaultStyle: {
    width: "100%",
    minHeight: 100,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Input",
  },
  snippet: {
    componentName: "Input.TextArea",
    package: "@mijadesign/web",
    props: { placeholder: "请输入", rows: 4 },
  },
};
